import React from 'react';
import PropTypes from 'prop-types';

import { 
  makeStyles,
} from '@material-ui/core/styles';

import {
  Grid,
} from '@material-ui/core';

import {
  AccountCircle 
} from '@material-ui/icons';

import { 
  default as Typography 
} from '../../utils/TypographyWithMargin';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: '200px',
  },
  userIcon: {
    display: 'flex',
    padding: 5,
  },
  userName: {
    textAlign: 'left',
    lineSpacing: 0,
  },
}));

export default function UserBadge(props) {
  const { userContext } = props;
  const classes = useStyles();

  if(!userContext) {
    return(null);
  }
  
  return (
    <Grid container className={classes.root} alignItems="center">
      <Grid item className={classes.userIcon}>
        <AccountCircle fontSize="large"/>
      </Grid>
      <Grid item className={classes.userName}>
        <Typography style={{ lineHeight: 1 }}>{userContext.fullname}</Typography>
        <Typography style={{ lineHeight: 1, fontSize: "0.75rem" }}>
          {userContext.clients[userContext.selectedClient]  ? 
            userContext.clients[userContext.selectedClient].EffectiveRole+" @ "+userContext.clients[userContext.selectedClient].ClientAccountAlias :
            userContext.role !== 'None' ? "Data Lake "+userContext.role : '\u00A0'
          }
        </Typography>
      </Grid>
    </Grid>
  );
}

UserBadge.propTypes = {
  userContext: PropTypes.object,
};

UserBadge.defaultProps = {
};

